module.exports = __webpack_public_path__ + "img/top_bg.c10459ea.png";